import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PhoneReportsComponent } from './phone-reports/phone-reports.component';
import { TranslateModule } from '@ngx-translate/core';
import { PhoneReportsService } from './services/phone-reports.service';
import { HttpClientModule } from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { SelectDateFormComponent } from './select-date-form/select-date-form.component';
import { PhoneReportsListComponent } from './phone-reports-list/phone-reports-list.component';
import { Phone0reportsItemComponent } from './phone0reports-item/phone0reports-item.component';
import { MaterialModule } from '@app/material.module';
import { MatSortModule } from '@angular/material';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    HttpClientModule,
    MaterialModule,
    TranslateModule,
    ReactiveFormsModule,
    FormsModule,
    MatSortModule,
  ],
  declarations: [PhoneReportsComponent, SelectDateFormComponent, PhoneReportsListComponent, Phone0reportsItemComponent],
  providers: [PhoneReportsService]
})
export class PhoneReportsModule { }



// WEBPACK FOOTER //
// ./src/app/phone-reports/phone-reports.module.ts